import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PagerComponent } from './pager.component';
/**
 * NgModule definition for the Pager component.
 */
export class PagerModule { static decorators: DecoratorInvocation[] = [
{ type: NgModule, args: [{
    imports: [CommonModule],
    declarations: [
        PagerComponent
    ],
    exports: [
        PagerComponent
    ]
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

function PagerModule_tsickle_Closure_declarations() {
/** @type {?} */
PagerModule.decorators;
/**
 * @nocollapse
 * @type {?}
 */
PagerModule.ctorParameters;
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
